export const Th = {
    // NOTE: Doesn't seem to be getting applied :/
    baseStyle: {
        fontWeight: "normal",
        color: "darkGray",
        textTransform: "Capitalize",
    },
};
